import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSignalEffect } from '@preact/signals-react/runtime'
import LayoutManager from './components/Layout/LayoutManager'
import { initAxiosErrorHandling } from './utils/db'
import { installGlobalErrorLogging } from '@client/utils/installGlobalErrorLogging.ts'
import { accessToken, user } from '@/client/stores/authStore'
import { connectSocketOnce, installSocketAutoReconnectHooks } from '@client/socket/socket.ts'
import { appVersion } from "./config/constants";
import ResetPassword from './components/ResetPassword';
import Demo from "./components/Demo";
import './App.scss'

declare global {
    interface Window {
        appVersion?: string
    }
}

installGlobalErrorLogging({
    //appVersion: import.meta.env.VITE_APP_VERSION, // or process.env…
    appVersion: appVersion,
    getUserId: () => user.value?._id ?? null,
})

export default function App() {
    //console.log('Loop App ...')
    useSignalEffect(() => {
        if (accessToken.value) {
            connectSocketOnce()
            installSocketAutoReconnectHooks()
        }
    })
    initAxiosErrorHandling()

    return (
        <>
            <Demo />
            <BrowserRouter>
                <Routes>
                    <Route path="/reset-password/:code" element={<ResetPassword />} />
                    <Route path="/*" element={<LayoutManager />} />
                </Routes>
            </BrowserRouter>
        </>
    )
}
